import * as React from 'react'
import { PropsWithChildren, ReactElement, useState } from 'react'
import { getId, ITooltipHostProps, Stack, TooltipHost } from '@fluentui/react'
import { useMount } from '@fluentui/react-hooks'

export type TooltipProps = PropsWithChildren<{
    hostProps: Omit<ITooltipHostProps, 'id'>
    display?: 'inherit' | 'inline' | 'inline-block' | 'block'
}>

export default function Tooltip(props: TooltipProps): ReactElement {
    const [id, setId] = useState<string>()
    useMount(() => setId(getId('tooltip-')))

    return (
        <TooltipHost id={id} styles={{ root: { display: props.display || 'inherit' } }} {...props.hostProps}>
            <Stack aria-describedby={id}>{props.children}</Stack>
        </TooltipHost>
    )
}
